let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gAi0m")).then(() => parcelRequire('2mqrN'));